export const formatMachinesListAsHTMLDiv = (machinesList) => {
  let htmlContent = '<div style="text-align: center">';
  machinesList.forEach(machine => {
    htmlContent += `<p style="padding-left: 20px"><strong>Kund:</strong> ${machine.CustomerName}, <strong>Kassanamn:</strong> ${machine.Name}, <strong>MachineId:</strong> ${machine.Id}</p>`;
  });
  htmlContent += '</div>';
  return htmlContent;
};